export default __webpack_public_path__ + "static/media/photo--lg--128.791c6c24.jpg";